import { stopAllBotsDepthConstants } from '../constants';

const stopAllDepthBots = (state, action) => {
    if (state === undefined) {
        return {
            stopAllBots: {},
            loading: false,
            error: null,
            success: false,
        };
    }

    switch (action.type) {
        case stopAllBotsDepthConstants.STOP_ALL_DEPTH_REQUEST:
            return {
                stopAllBots: {},
                loading: true,
                error: null,
                success: false,
            };

        case stopAllBotsDepthConstants.STOP_ALL_DEPTH_SUCCESS:
            return {
                stopAllBots: action.payload,
                loading: false,
                error: null,
                success: true,
            };

        case stopAllBotsDepthConstants.STOP_ALL_DEPTH_FAILURE:
            return {
                stopAllBots: {},
                loading: false,
                error: action.payload,
                success: false,
            };

        default:
            return state;
    }
};

export default stopAllDepthBots;
